export default __webpack_public_path__ + "static/media/VitaminB12.239eca32.svg";